module.exports = __webpack_public_path__ + "img/ozone_test.eb8a40ef.jpg";